import init from './artwork-carousel';
export default init;
